<template>
  <div>
    <md-card-actions md-alignment="space-between">
      <div class="">
        <p class="card-category">
          {{ $t("common.show") }} {{ pagination.from }} {{ $t("common.to") }}
          {{ pagination.to }} {{ $t("common.of") }} {{ pagination.total }}
          {{ $t("common.entries") }}
        </p>
      </div>
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="pagination.total"
        @input="changePage"
      >
      </pagination>
    </md-card-actions>
  </div>
</template>

<script>
import { Pagination } from "@/components";

export default {
  name: "BasePagination",
  data() {
    return {
      initPage: true
    };
  },
  props: ["pagination"],
  components: { Pagination },
  methods: {
    changePage() {
      if (this.initPage) {
        this.initPage = false;
        return;
      }
      this.$emit("changePage");
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
